import axios from 'axios'

export default {
    AllCareers(state){
        axios.get(state.root + 'careers')
          .then(function (response) {
            //console.log(response.data[0].acf.ncu_media)
            state.careers = []
            let q = response.data
            console.log(q)
            for(let i =0; i < 10; i++){
            let k = {}
            k.title = q[i].title['rendered']
            k.articleType = q[i].type
            k.slug = q[i].slug
            k.id = q[i].id
            k.date_created = q[i].date
            k.application_deadline = q[i].acf.application_deadline
            k.department_name = q[i].acf.department_name
            k.job_title = q[i].acf.job_title
            k.job_application = q[i].acf.job_application
    
            state.careers.push(k)
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
}